import React, { useEffect, useState, Fragment, useMemo } from "react";
import { connect } from "react-redux";
import StandardOrder from "./StandardOrder";
import ManagedPlatform from "./forms/ManagedPlatform";
import PlainInstance from "./forms/PlainInstance";
import PamInstance from "./forms/PamInstance";
import OnPremiseService from "./forms/OnPremiseService";
import AutomationAnywhereLicenses from "./forms/AutomationAnywhereLicenses";
import AutomaticTicketResolver from "./forms/AutomaticTicketResolver";
import EventOps from "./forms/EventOps";
import AutomaticTicketResolverSaaS from "./forms/AutomaticTicketResolverSaaS";
import StormSeer from "./forms/StormSeer";
import Turing from "./forms/Turing";
import Pamktka from "./forms/Pamktka";
import DedicatedVirtualNetworkSetup from "./forms/DedicatedVirtualNetworkSetup.jsx";
import Bedrock from "./forms/Bedrock";
import axios from "axios";
import GenWiz from "../common/Popups/Genwizui";
import GenWizardAgent from "./forms/GenWizardAgent.jsx";
import AutonomousOps from "./forms/AutonomousOps.jsx";

import AppStepper from "./AppStepper";
import { withRouter } from "react-router-dom";
import reducer, * as fuiRedux from "../../redux/fui/index";
import moment from "moment";
import PropTypes from "prop-types";
import priceConfig from "./forms/pricetotierMapping";

import { tokenValidation } from "../../helper/customizedHooks";
import DedicatedPlatform from "./forms/DedicatedPlatform";
import GenWizardPlatform from "./forms/GenWizardPlatform";
import ADPlatform from "./forms/ADPlatform";
import UTKMPlatform from "./forms/UTKM";
import WindowsProvisioningPlatform from "./forms/WindowsProvisioningPlatform";
import SplunkCluster from "./forms/SplunkCluster";
import Stack360 from "./forms/Stack360";
import ServiceIntegrator from "./forms/ServiceIntegrator";
import Ec2ClaudeCode from "./forms/Ec2ClaudeCode";
import AgentMesh from "./forms/AgentMesh";
import Cia from "./forms/Cia";
import SubmitSuccess from "./SubmitSuccess";
import SubmitFailed from "./SubmitFailed";
import SubmitInternal from "./SubmitInternal.js";
import {
  PageWrapper,
  StepOnePaper,
  ButtonWrapper,
  ConfigurationWrapper,
  StyledSpan,
  StyledSnackbar,
} from "./FuiStyles";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import uuidv4 from "uuidv4";
import { PrimaryButton } from "../common/CommonComponents/Buttons";
import { appNameProjectId } from "./Constants/ProductIds";
import { FormValidate } from "./FormValidator";
import {
  generateDPSubmitData,
  generateGWLSubmitData,
  generateADSubmitData,
  generateWPSubmitData,
  generateMPSubmitData,
  generatePISubmitData,
  generateOPSSubmitData,
  generateAALSubmitData,
  generateATRSubmitData,
  generateEventOpsSubmitData,
  generateTuringSubmitData,
  generateStormSeerSubmitData,
  generateATRSaaSSubmitData,
  generatePAMSubmitData,
  generateUTKMSubmitData,
  generateSplunkClusterSubmitData,
  generateStack360SubmitData,
  generateSISubmitData,
  generateECCSubmitData,
  generateAMSubmitData,
  generateKQSubmitData,
  generateCIASubmitData,
  generateCPSubmitData,
  generateBRSubmitData,
  generateGASubmitData,
  generateAOPSubmitData,
} from "../../helper/fuiDataConvert";

import { CommonDialog } from "../common/CommonComponents/Dialog";
import { AcceptButton, DeclineButton } from "../common/CommonComponents/Buttons";
import { DialogActions } from "@material-ui/core";
import { Table, TableCell, TableBody, TableRow, CircularProgress, MenuItem, TextField, Box, Typography, Grid, CardContent, Card } from "@material-ui/core";
import { BoldTableCell, DetailTableWrapper } from "./FuiStyles";
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from "@material-ui/core/Button";
import AcknowledgementService from '../../services/acknowledgementService.js';
//added by ernesto caballero aka Mukong
import View from "./Dialogs/View";
import base from "../../config.js";
import ReverseEngineering from "./forms/ReverseEngineering.jsx";
import { hideSensitiveData } from "./forms/CommonFunctions.js";
import GenWizardAgentBeta from "./forms/GenWizardAgentBeta.jsx";
/**
 * Fui page for platforms
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: FulfilmentUI
 */
const PlatformLicenseStepper = ({
  match: {
    params: { routeName },
  },
  updateASelectedInstance,
  listenerClearLocalData,
  classes,
  configurationType,
  email,
  isUserApprovalWhitelisted,
  history,
  DPForm,
  GWLForm,
  ADForm,
  WPForm,
  submitForm,
  submitFormNonApproval,
  submitFormWhitelistedUser,
  submitFormEnhancedApproval,
  validateForm,
  checkIsUserApprovalWhitelisted,
  isFormSubmittedSuccessful,
  isFormValidationSuccessful,
  isFormSubmittedFailed,
  MPForm,
  PIForm,
  OPSForm,
  AALForm,
  ATRForm,
  GAForm,
  AOPForm,
  EventOpsForm,
  TuringForm,
  StormSeerForm,
  ATRSaaSForm,
  PAMForm,
  UTKMForm,
  SPLUCLUForm,
  Stack360Form,
  SIForm,
  ECCForm,
  KQForm,
  AMForm,
  CIAForm,
  CPForm,
  BRForm,
  isRootExist,
  externalClientError,
  activeStep,
  isLoading,
  approversData,
  approversEnhancedData,
  approversGtad,
  validationData,
  apiError,
  isSubmitFormLoading,
  updateLoading,
  updateSuccessSubmit,
  updateFailedSubmit,
  updateCPForm
}) => {
  const [selectedEnvironment, setSelectedEnvironment] = useState("");
  const [selectedClientname, setSelectedClientname] = useState("");
  const [agreementAccepted, setAgreementAccepted] = useState(false);
  const [acknowledgementData, setAcknowledgementData] = useState(null);
  const [acknowledgementLoading, setAcknowledgementLoading] = useState(false);
  const [acknowledgementError, setAcknowledgementError] = useState(null);
  const [selectedForm, setSelectedForm] = useState("");
  const [sapContractIdValue, setSAPContractIDValue] = useState("");
  // Dedicated VPC independent approval states
  const [showDedicatedVPCApproval, setShowDedicatedVPCApproval] = useState(false);
  const [dedicatedVPCApprovers, setDedicatedVPCApprovers] = useState([]);
  const [selectedDedicatedVPCApprover, setSelectedDedicatedVPCApprover] = useState("");

  // Dedicated VPC custom review states
  const [showDedicatedVPCReview, setShowDedicatedVPCReview] = useState(false);
  const [dedicatedVPCReviewData, setDedicatedVPCReviewData] = useState({});
  const [dedicatedVPCLoading, setDedicatedVPCLoading] = useState(false);
  const [minDate, setMinDate] = useState(undefined);
  const [maxDate, setMaxDate] = useState(undefined);

  const [serviceEndDateValue, setServiceEndDateValue] = useState("");
  const [isServiceEndDateInvalid, setIsServiceEndDateInvalid] = useState(false);
  //   const [serviceEndDateValid, setServiceEndDateValid] = useState(true);
  const [isEncrypt, setEncrypt] = useState(false);
  const [orderUId, setOrderUId] = useState("");
  const [orderItemUId, setOrderItemUId] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [gwconfig, setgenwiz] = useState({ stateFunction: setgenwiz });


  // check whether all fields are validated
  const [isAllValid, setIsAllValid] = useState(false);

  const [notesValidations, setNotesValidations] = useState({
    emptyString: false,
    maxLength: false,
  });

  //   const [userValidations, setUsersValidations] = useState({
  //     emptyString: false,
  //   });

  // open and close the submit unsuccessful Snackbar
  const [open, setOpen] = useState(false);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState(false);
  const [openValidationPopup, setOpenValidationPopup] = useState(false);

  //view vy ernesto
  const [showView, setShowView] = useState(false);
  const [formData, setFormData] = useState({});
  const [formLabel, setFormLabel] = useState({});
  const [showOrderInfo, setShowOrderInfo] = useState(false);
  const [orderId, setOrderId] = useState(null);

  // const handleConfirmation = () => {
  //   setOpenConfirmationPopup(true);
  // };

  const generateConfirmPopup = (form, configurationType) => {
    setSelectedForm(form);
    setOpenConfirmationPopup(true);

    // Determine order type and fetch acknowledgement message
    const orderType = configurationType === 'quick' ? 'internal' : 'client';
    fetchAcknowledgementMessage(orderType);
  };

  // Format acknowledgement text for better display
  const formatAcknowledgementText = (text) => {
    if (!text) return '';

    // Split by lines and process each line
    return text
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0)
      .map((line, index) => {
        // Check if line starts with number pattern (1., 2., etc.)
        const numberMatch = line.match(/^(\d+\.?\s*)(.*)/);
        if (numberMatch) {
          const [, number, content] = numberMatch;
          return (
            <div key={index} style={{
              display: 'flex',
              marginBottom: '6px',
              alignItems: 'baseline',
              paddingLeft: '12px',
              lineHeight: '1.5'
            }}>
              <span style={{
                minWidth: '20px',
                fontWeight: '500',
                color: '#6b7280',
                marginRight: '2px',
                lineHeight: '1.5'
              }}>
                {number}
              </span>
              <span style={{
                flex: 1,
                lineHeight: '1.5'
              }}>
                {content}
              </span>
            </div>
          );
        }
        // Regular line without numbering
        return (
          <div key={index} style={{ marginBottom: '6px', paddingLeft: '12px' }}>
            {line}
          </div>
        );
      });
  };

  const fetchAcknowledgementMessage = async (orderType) => {
    try {
      setAcknowledgementLoading(true);
      setAcknowledgementError(null);
      const result = await AcknowledgementService.getAcknowledgementMessage(orderType, 'requester');
      if (result.success) {
        setAcknowledgementData(result.data);
      } else {
        setAcknowledgementError(result.error);
      }
    } catch (error) {
      setAcknowledgementError('Failed to load acknowledgement message');
    } finally {
      setAcknowledgementLoading(false);
    }
  };

  const submitFormClick = () => {
    if (isFinished && isAllValid)
      handleConfirm()
    else
      handleClick()
  }

  const submitFormData = () => {
    if (routeName === 'dedicatedvirtualnetworksetup') {
      // Close the review popup and show loader
      setShowView(false);
      setDedicatedVPCLoading(true);
      // Independent Dedicated VPC approval workflow
      handleDedicatedVPCApproval();
    }
    if (routeName === 'BedrockPlatform')
      BedrockSubmit();
  }

  // Independent Dedicated VPC approval workflow
  const handleDedicatedVPCApproval = () => {
    // Close review popup
    setShowView(false);

    // Create corrected form data for Dedicated VPC
    const dedicatedVPCData = {
      ...CPForm,
      AaamPlatformType: "DedicatedVPC",
      TeamName: "DEDICATEDVPC"
    };

    // Call approvers-enhanced API for Dedicated VPC (consistent with other forms)
    const approversUrl = `${base.app.apiSite}get-details/approvers-enhanced`;
    const params = {
      AaamPlatformType: "DedicatedVPC",
      ProductUId: appNameProjectId.connectivityid,
      DealType: "Not applicable",
      DeploymentPhase: "Not applicable",
      Environment: "Production",
      ConfigurationType: "full"
    };

    // Make approvers API call
    const idToken = localStorage.getItem("token");
    axios.get(approversUrl, {
      headers: { Authorization: idToken },
      params: params
    })
      .then((res) => {
        // Store approvers data and show confirmation popup
        // Hide loader
        setDedicatedVPCLoading(false);

        if (res.data && res.data.level1_approvers && res.data.level1_approvers.length > 0) {
          // Handle new approvers-enhanced response format
          const approversList = res.data.level1_approvers;

          // Store approvers data for the dropdown
          setDedicatedVPCApprovers(approversList);
          setShowDedicatedVPCApproval(true);
        } else {
          // No approvers, submit directly
          handleDedicatedVPCSubmission();
        }
      })
      .catch((err) => {
        // console.error('Dedicated VPC: Error fetching approvers:', err);
        // Hide loader
        setDedicatedVPCLoading(false);
        // On error, proceed without approval
        handleDedicatedVPCSubmission();
      });
  };

  // Independent Dedicated VPC submission
  const handleDedicatedVPCSubmission = () => {
    // The formData already contains all the processed form data from submitFormClick2
    // We just need to add the system fields and submit directly
    saveCPRequest();
  };

  const submitFormClick2 = (data) => {
    setShowView(true);

    // Create a clean data structure for display
    const displayData = {};
    const displayLabels = [];

    // Add fields conditionally based on what's available in data
    if (data.SAPContractID) {
      displayData['SAPContractID'] = data.SAPContractID;
      displayLabels.push('SAP Contract ID');
    }

    if (data.ClientName) {
      displayData['ClientName'] = data.ClientName;
      displayLabels.push('Client Name');
    }

    if (data.EndToEndUId) {
      displayData['EndToEndUId'] = data.EndToEndUId;
      displayLabels.push('End-to-End UID');
    }
    if (data.ProjectName) {
      displayData['ProjectName'] = data.ProjectName;
      displayLabels.push('Project Name');
    }

    if (data.WBSEcode) {
      displayData['WBSEcode'] = data.WBSEcode;
      displayLabels.push('WBSE Code');
    }


    if (data.LLMProvider) {
      displayData['LLMProvider'] = data.LLMProvider === 'client' ? 'Client LLM' : 'Accenture LLM';
      displayLabels.push('LLM Provider');
    }

    if (data.DeploymentLead) {
      displayData['DeploymentLead'] = data.DeploymentLead;
      displayLabels.push('Deployment Lead');
    }

    if (data.DeliveryLead) {
      displayData['DeliveryLead'] = data.DeliveryLead;
      displayLabels.push('Delivery Lead');
    }

    if (data.CloudPlatform) {
      displayData['CloudPlatform'] = data.CloudPlatform;
      displayLabels.push('Cloud Platform');
    }

    if (data.ConnectivityType) {
      displayData['ConnectivityType'] = data.ConnectivityType;
      displayLabels.push('Connectivity Type');
    }

    if (data.GDPR) {
      displayData['GDPR'] = data.GDPR === 'yes' ? 'GDPR Compliant' : 'Non-GDPR';
      displayLabels.push('GDPR Compliance');
    }

    if (data.DeploymentRegion) {
      displayData['DeploymentRegion'] = data.DeploymentRegion;
      displayLabels.push('Deployment Region');
    }

    if (data.AppList) {
      // Map short app names to display names for Dedicated Virtual Network Setup
      const appDisplayNames = {
        'KM': 'Knowledge Manager',
        'Steward': 'Steward',
        'CUI': 'CUI',
        'ATR': 'ATR',
        'Codev': 'Codev',
        'SplunkTA': 'Splunk TA',
        'AgentManager': 'Agent Manager',
        'EventOps': 'EventOps'
      };

      let appListDisplay;
      if (typeof data.AppList === 'string') {
        // If it's already a comma-separated string, split and map
        const apps = data.AppList.split(',');
        appListDisplay = apps.map(app => appDisplayNames[app.trim()] || app.trim()).join(', ');
      } else if (Array.isArray(data.AppList)) {
        // If it's an array, map directly
        appListDisplay = data.AppList.map(app => appDisplayNames[app] || app).join(', ');
      } else {
        appListDisplay = data.AppList;
      }

      displayData['AppList'] = appListDisplay;
      displayLabels.push('Applications To Provision');
    }

    // Add application instance types
    const appTypes = [];
    const appDisplayNames = {
      'KM': 'Knowledge Manager',
      'Steward': 'Steward',
      'CUI': 'CUI',
      'ATR': 'ATR',
      'Codev': 'Codev',
      'SplunkTA': 'Splunk TA',
      'AgentManager': 'Agent Manager',
      'EventOps': 'EventOps'
    };

    Object.keys(data).forEach(key => {
      if (key.endsWith('_InstanceType')) {
        const appName = key.replace('_InstanceType', '');
        const displayName = appDisplayNames[appName] || appName;
        const instanceType = data[key].charAt(0).toUpperCase() + data[key].slice(1); // Capitalize first letter
        appTypes.push(`${displayName}: ${instanceType}`);
      }
    });

    if (appTypes.length > 0) {
      displayData['AppInstanceTypes'] = appTypes.join(', ');
      displayLabels.push('Application Instance Types');
    }

    if (data.RequestNotes) {
      displayData['RequestNotes'] = data.RequestNotes;
      displayLabels.push('Request Notes');
    }

    if (data.Configuration) {
      displayData['Configuration'] = data.Configuration === 'quick' ? 'Internal User' : 'Client';
      displayLabels.push('Configuration Type');
    }

    if (data.TentativeServiceEndDate) {
      // Format the date for display - handle both Date objects and date strings
      let formattedDate;
      if (data.TentativeServiceEndDate instanceof Date) {
        formattedDate = data.TentativeServiceEndDate.toLocaleDateString();
      } else {
        // If it's a string (YYYY-MM-DD format), convert to display format
        const dateObj = new Date(data.TentativeServiceEndDate + 'T00:00:00');
        formattedDate = dateObj.toLocaleDateString();
      }
      displayData['TentativeServiceEndDate'] = formattedDate;
      displayLabels.push('Service End Date');
    }

    setFormData(displayData);
    setFormLabel(displayLabels);
  }
  //conenctivity platform save
  const saveCPRequest = () => {

    // For Dedicated VPC, use formData (which contains all processed form data from submitFormClick2)
    // For others, use CPForm as before
    const sourceData = routeName === 'dedicatedvirtualnetworksetup' ? formData : CPForm;
    const postData = { ...sourceData }
    postData['OrderUID'] = uuidv4();
    postData['productUID'] = appNameProjectId.connectivityid;

    // Add additional keys for Dedicated VPC payload
    if (routeName === 'dedicatedvirtualnetworksetup') {
      // Add system/platform fields
      postData['AaamPlatformType'] = 'DedicatedVPC';
      postData['TeamName'] = 'DEDICATEDVPC';

      // Add approval fields
      postData['Approver'] = selectedDedicatedVPCApprover || "NA";
      postData['ApprovalStatus'] = selectedDedicatedVPCApprover ? "Pending Approval" : "NA";
      postData['CustomerEnterpriseID'] = email ? email.split("@")[0] : '';
      postData['OrderItemUId'] = orderItemUId || uuidv4();
      postData['CAMPortalEnvironment'] = process.env.REACT_APP_CAMENVPORTAL;

      // Add new required fields
      postData['CreatedBy'] = email ? email.split("@")[0] : '';
      postData['CreatedDate'] = new Date().toISOString(); // Current timestamp
      postData['Initiative'] = 'GenWizard AiOps'; // Always GenWizard AiOps for Dedicated VPC

      // Add Service End Date if provided (from form data)
      if (postData['TentativeServiceEndDate']) {
        postData['TentativeServiceEndDate'] = `${postData['TentativeServiceEndDate']}T00:00:00.000Z`;
      }
    }
    const idToken = localStorage.getItem("token");
    if (idToken === null || idToken === undefined) {
      window.location.href = "/"
      return false;
    }
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };
    // const urls = `${base.app.apiSite}provision/mywizard-aiops/NewClientRequest`;
    const urls = `${base.app.apiSite}provision/mywizard-aiops/dedicated-vpc-deployment-request/submit`;
    // hide form
    updateLoading();
    setShowOrderInfo(false);
    axios.post(
      urls, postData, urloptions
    ).then((resp) => {
      setOrderItemUId(postData['OrderItemUId']);
      updateSuccessSubmit(postData['OrderItemUId']);
    }).catch((error) => {
      setOrderItemUId(postData['OrderItemUId']);
      updateFailedSubmit();
    });
  }

  const submitFormClick3 = (data) => {
    setShowView(true);
    setFormData(data);
    setFormLabel([
      'SAP contactID',
      'Region',
      'WBSE Code',
      'Primary POC',
      'Secondary POC',
      'Model Name',
      'Environment',
      'Client Name',
      'Notes',
      'Client'
    ]);
  }

  const BedrockSubmit = () => {
    const idToken = localStorage.getItem("token");
    const url = `${base.app.apiSite}bedrock/create`;
    let payloaddata = isUserApprovalWhitelisted
      ? generateBRSubmitData(
        generateNewFormBr(BRForm, configurationType),
        orderUId,
        orderItemUId,
        createdBy,
        generateUserOrder(BRForm, appNameProjectId.connectivityid),
        "myWizard AiOps"
      )
      : generateBRSubmitData(
        generateNewFormBr(BRForm, configurationType),
        orderUId,
        orderItemUId,
        createdBy,
        generateUserOrder(BRForm, appNameProjectId.bedrockid),
        "myWizard AiOps"
      );

    const urloptions = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      },
    };

    setShowView(false);
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Processing the Order...',
      }
    });
    axios.post(url, payloaddata, urloptions)
      .then((resp) => {
        // Use Redux action to trigger submit success popup
        submitFormNonApproval({
          orderItemUId: resp.data.orderItemUId || orderItemUId,
          createdBy,
          payload: payloaddata,
        });
        setgenwiz({});
      })
      .catch((err) => {
        setgenwiz({});
        // console.error("Failed to submit order:", err);

        // Use Redux action to trigger submit failed popup
        submitFormNonApproval({
          orderItemUId,
          createdBy,
          payload: payloaddata,
          failed: true,
        });
      });
  };


  const closeClick = () => {
    setShowView(false);
    setFormData({});
  }

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setOpenConfirmationPopup(false)
    setOpenValidationPopup(false)
  };
  // update the instance selected in step two, and changing when routeName changes
  useEffect(() => {
    updateASelectedInstance({});
  }, [routeName]);

  useEffect(() => {
    setOrderUId(uuidv4());
    // Using a different generation for this value due to new requirements.
    setOrderItemUId(uuidv4());
  }, []);

  // get user's EID from email
  useEffect(() => {
    checkIsUserApprovalWhitelisted();
    if (email) {
      let eid = email ? email.split("@")[0] : "";
      setCreatedBy(eid);
    }
  }, [email, isUserApprovalWhitelisted]);

  useEffect(() => {
    setSelectedEnvironment("");
    setSelectedClientname("");
    setSAPContractIDValue("");
    setMinDate(undefined);
    setMaxDate(undefined);
    setServiceEndDateValue("");
    setIsServiceEndDateInvalid(false);
    // setServiceEndDateValid(true);
    setNotesValidations({
      emptyString: false,
      maxLength: false,
    });
  }, [listenerClearLocalData]);

  let getMaxDate = (date) => {
    const maxDateEnv = moment()
      .add(date, "days")
      .format("YYYY-MM-DD");
    return maxDateEnv;
  };

  const getNotesValue = (values) => {
    setNotesValidations(values);
  };

  //   const getUsersValue = (values) => {
  //     setUsersValidations(values);
  //   };

  const getSelectedClientname = (selectedClientnameValue) => {
    setSelectedClientname(selectedClientnameValue)
  }

  const getSAPContractIDValue = (getSAPContractIDValue) => {
    setSAPContractIDValue(getSAPContractIDValue)
  }

  const getSelectedEnvironment = (selectedEnvironmentValue) => {
    setSelectedEnvironment(selectedEnvironmentValue);
    const currentDate = moment().format("YYYY-MM-DD");
    setMinDate(currentDate);
    if (selectedEnvironmentValue === "Dev") {
      const endDate = getMaxDate(28);
      setMaxDate(endDate);
    } else if (selectedEnvironmentValue === "Test") {
      let endDate = getMaxDate(2);
      if (configurationType === "full") {
        endDate = getMaxDate(1826);
      }
      setMaxDate(endDate);
    } else if (selectedEnvironmentValue === "Sales") {
      const endDate = getMaxDate(60);
      setMaxDate(endDate);
    } else if (selectedEnvironmentValue === "Production") {
      const endDate = getMaxDate(1826);
      setMaxDate(endDate);
    }
  };

  const getServiceEndDate = (valueServiceEndDateValue) => {
    const formatDate = moment(valueServiceEndDateValue).format("YYYY-MM-DD");
    setServiceEndDateValue(formatDate);
    const [maxYear, maxMonth, maxDay] = maxDate ? maxDate.split("-") : "";
    const [minYear, minMonth, minDay] = minDate ? minDate.split("-") : "";
    const [year, month, day] = formatDate ? formatDate.split("-") : formatDate;
    let maxDateValidation = new Date(maxYear, maxMonth - 1, maxDay);
    let minDateValidation = new Date(minYear, minMonth - 1, minDay);
    let serviceEndDateValidation = new Date(year, month - 1, day);

    if (
      serviceEndDateValidation >= minDateValidation &&
      serviceEndDateValidation <= maxDateValidation
    ) {
      setIsServiceEndDateInvalid(false);
    } else {
      setIsServiceEndDateInvalid(true);
    }
  };

  useEffect(() => {
    let endDate;
    let currentDate = moment().format("YYYY-MM-DD");
    if (selectedEnvironment) {
      if (selectedEnvironment === "Dev") {
        endDate = getMaxDate(28);
      } else if (selectedEnvironment === "Test") {
        if (configurationType === "full") {
          endDate = getMaxDate(1826);
        } else {
          endDate = getMaxDate(2);
        }
      } else if (selectedEnvironment === "Sales") {
        endDate = getMaxDate(60);
      } else if (selectedEnvironment === "Production") {
        endDate = getMaxDate(1826);
      } else {
        setIsServiceEndDateInvalid(false);
      }

      if (serviceEndDateValue) {
        const [maxYear, maxMonth, maxDay] = endDate && endDate.split("-");
        const [minYear, minMonth, minDay] =
          currentDate && currentDate.split("-");
        const [year, month, day] =
          serviceEndDateValue && serviceEndDateValue.split("-");

        let maxDateValidation = new Date(maxYear, maxMonth - 1, maxDay);
        let minDateValidation = new Date(minYear, minMonth - 1, minDay);
        let serviceEndDateValidation = new Date(year, month - 1, day);

        if (
          serviceEndDateValidation >= minDateValidation &&
          serviceEndDateValidation <= maxDateValidation
        ) {
          //   setServiceEndDateValid(false);
          setIsServiceEndDateInvalid(false);
        } else {
          //   setServiceEndDateValid(true);
          setIsServiceEndDateInvalid(true);
        }
      }
    } else {
      setIsServiceEndDateInvalid(false);
    }
  }, [selectedEnvironment, serviceEndDateValue]);

  const isAALFinished = !FormValidate(
    AALForm,
    configurationType,
    "AutomationAnywhereLicenses"
  );

  const isOPSFinished = !FormValidate(
    OPSForm,
    configurationType,
    "OnPremiseService"
  );

  const isDPFinished = !FormValidate(
    DPForm,
    configurationType,
    "DedicatedPlatform",
    isRootExist,
    externalClientError
  );

  const isGWLFinished = !FormValidate(
    GWLForm,
    configurationType,
    "GenWizardPlatform",
    isRootExist,
    externalClientError
  );

  const isADFinished = !FormValidate(
    ADForm,
    configurationType,
    "ADPlatform",
    isRootExist,
    externalClientError
  );

  const isWPFinished = !FormValidate(
    WPForm,
    configurationType,
    "WindowsProvisioningPlatform",
    isRootExist,
    externalClientError
  );

  const isMPFinished = !FormValidate(
    MPForm,
    configurationType,
    "ManagedPlatform",
    isRootExist,
    externalClientError
  );

  const isPIFinished = !FormValidate(
    PIForm,
    configurationType,
    "PlainInstance",
    isRootExist,
    externalClientError
  );
  const isGAFinished = !FormValidate(
    GAForm,
    configurationType,
    "GenwizardAgent",
    isRootExist,
    externalClientError,
  );
  //autonomous ops
  const isAOPFinished = !FormValidate(
    AOPForm,
    configurationType,
    "autonomousops",
    isRootExist,
    externalClientError
  );
  
  const isPAMFinished = !FormValidate(
    PAMForm,
    configurationType,
    "PamInstance",
    isRootExist,
    externalClientError
  );

  const isUTKMFinished = !FormValidate(
    UTKMForm,
    configurationType,
    "UTKMPlatform",
    isRootExist,
    externalClientError
  );

  const isATRFinished = !FormValidate(
    ATRForm,
    configurationType,
    "AutomaticTicketResolver",
    isRootExist,
    externalClientError
  );

  const isEventOpsFinished = !FormValidate(
    EventOpsForm,
    configurationType,
    "EventOps",
    isRootExist,
    externalClientError
  )

  const isTuringFinished = !FormValidate(
    TuringForm,
    configurationType,
    "Turing",
    isRootExist,
    externalClientError
  );

  const isStormSeerFinished = !FormValidate(
    StormSeerForm,
    configurationType,
    "StormSeer",
    isRootExist,
    externalClientError
  );

  const isATRSaaSFinished = !FormValidate(
    ATRSaaSForm,
    configurationType,
    "AutomaticTicketResolverSaaS",
    isRootExist
  );

  const isSPLUCLUFinished = !FormValidate(
    SPLUCLUForm,
    configurationType,
    "SplunkClusterPlatform",
    isRootExist,
    externalClientError
  );

  const isStack360Finished = !FormValidate(
    Stack360Form,
    configurationType,
    "Stack360"
  );
  const isKQFinished = !FormValidate(
    KQForm,
    configurationType,
    "Pamktka",
    isRootExist,
    externalClientError
  );
  const isSIFinished = !FormValidate(
    SIForm,
    configurationType,
    "ServiceIntegrator",
    SIForm.InstanceType === 'Dedicated' ? isRootExist : false, //for splunk integration by pass isroot for checking domain name
    externalClientError
  );
  const isECCFinished = !FormValidate(
    ECCForm,
    configurationType,
    "Ec2ClaudeCode",
    isRootExist,
    externalClientError
  );
  const isAMFinished = !FormValidate(
    AMForm,
    configurationType,
    "AgentMesh",
    isRootExist,
    externalClientError
  );
  const isCIAFinished = !FormValidate(
    CIAForm,
    configurationType,
    "CIA",
    isRootExist,
    externalClientError
  );
  const isCPFinished = !FormValidate(
    CPForm,
    configurationType,
    "DedicatedVirtualNetworkSetup",
    isRootExist,
    externalClientError
  );
  const isBRFinished = !FormValidate(
    CPForm,
    configurationType,
    "BedrockPlatform",
    isRootExist,
    externalClientError
  );

  // either user finish Full or Quick, isFinished would be true
  const isFinished =
    isDPFinished ||
    isGWLFinished ||
    isADFinished ||
    isWPFinished ||
    isMPFinished ||
    isPIFinished ||
    isPAMFinished ||
    isUTKMFinished ||
    isAALFinished ||
    isOPSFinished ||
    isATRFinished ||
    isEventOpsFinished ||
    isTuringFinished ||
    isStormSeerFinished ||
    isATRSaaSFinished ||
    isSPLUCLUFinished ||
    isStack360Finished ||
    isSIFinished ||
    isKQFinished ||
    isECCFinished ||
    isAMFinished ||
    isCIAFinished ||
    isCPFinished ||
    isGAFinished ||
    isAOPFinished ||
    isBRFinished;

  const generateNewForm = (form, configuration) => {
    const commonFullData = {};
    const commonData = {
      Approver: isUserApprovalWhitelisted ? "NA" : selectedApprover,
      // ApprovedBy: email ? email.slipt("@")[0]: "",
      ApprovalStatus: isUserApprovalWhitelisted ? "NA" : "Pending L1 Approval",
      DMSId: form.DomainContextRoot ? form.DomainContextRoot : form.DMSId,
      EndToEndUId: form.EndToEndUId
        ? form.EndToEndUId
        : form.DomainContextRoot
          ? form.DomainContextRoot
          : form.DMSId,
      DeployRegion: form.DeployRegion ? form.DeployRegion : "UNKNOWN",
      ClientName: form.ClientName
        ? form.ClientName
        : form.VendorName === "MCC"
          ? "MCC"
          : "myWizard AiOps",
      SAPContractID: form.SAPContractID
        ? form.SAPContractID
        : form.DomainContextRoot
          ? form.DomainContextRoot
          : form.DMSId,

      GeographicArea: form.GeographicArea ? form.GeographicArea : "UNKNOWN",
      BenefitsExpected: form.BenefitsExpected ? form.BenefitsExpected : 1,
      DailyDataVolume: form.DailyDataVolume ? form.DailyDataVolume : 0,
      Users: form.Users ? form.Users : "UNKNOWN",
      ConcurrentUsers: form.ConcurrentUsers ? form.ConcurrentUsers : 0,
      CustomerMobileNo: form.CustomerMobileNo
        ? form.CustomerMobileNo
        : "UNKNOWN",
      ServiceGroup: form.ServiceGroup ? form.ServiceGroup : "UNKNOWN",
      UsersDistributionGroup: form.UsersDistributionGroup
        ? form.UsersDistributionGroup
        : "UNKNOWN",
      CustomerEnterpriseID: createdBy,
      TentativeServiceEndDate: `${form.TentativeServiceEndDate}T00:00:00.000Z`,
      VendorName: form.VendorName,
      Initiative:
        form.VendorName === "pam"
          ? "PAM"
          : form.VendorName === "MCC"
            ? "MCC"
            : "myWizard AiOps",
    };

    return configuration === "full"
      ? { ...form, ...commonData, ...commonFullData }
      : { ...form, ...commonData };
  };

  //bedrockprovisioning generate form
  const generateNewFormBr = (form, configuration) => {
    const commonFullData = {};
    const commonData = {
      DeployRegion: form.DeployRegion ? form.DeployRegion : "UNKNOWN",
      ClientName: form.ClientName
        ? form.ClientName
        : form.VendorName === "MCC"
          ? "MCC"
          : "myWizard AiOps",
      SAPContractID: form.SAPContractID
        ? form.SAPContractID
        : form.DomainContextRoot
          ? form.DomainContextRoot
          : form.DMSId,
      CustomerEnterpriseID: createdBy,
      // TentativeServiceEndDate: `${form.TentativeServiceEndDate}T00:00:00.000Z`,
      VendorName: form.VendorName,
      Initiative:
        form.VendorName === "pam"
          ? "PAM"
          : form.VendorName === "MCC"
            ? "MCC"
            : "myWizard AiOps",
    };

    return configuration === "full"
      ? { ...form, ...commonData, ...commonFullData }
      : { ...form, ...commonData };
  };

  // the function to confirm submission
  const handleConfirm = () => {
    switch (routeName) {
      case "managedPlatform":
        generateConfirmPopup(MPForm, configurationType);
        break;

      case "dedicatedPlatform":
        generateConfirmPopup(DPForm, configurationType);
        break;

      case "genWizardPlatform":
        generateConfirmPopup(GWLForm, configurationType);
        break;

      case "adPlatform":
        generateConfirmPopup(ADForm, configurationType);
        break;

      case "windowsProvisioningPlatform":
        generateConfirmPopup(WPForm, configurationType);
        break;

      case "plainInstance":
        generateConfirmPopup(PIForm, configurationType);
        break;

      case "plainInstanceMcc":
        generateConfirmPopup(PIForm, configurationType);
        break;

      case "pamInstance":
        generateConfirmPopup(PAMForm, configurationType);
        break;

      case "utkmPlatform":
        generateConfirmPopup(UTKMForm, configurationType);
        break;
      case "pamktka":
        generateConfirmPopup(KQForm, configurationType);
        break;
      case "genwizardAgent":
        generateConfirmPopup(GAForm, configurationType);
        break;
      case "autonomousops":
        generateConfirmPopup(AOPForm, configurationType);
        break;

        return;
      case "automaticTicketResolver":
        generateConfirmPopup(ATRForm, configurationType);
        break;

      case "eventOpsPlatform":
        generateConfirmPopup(EventOpsForm, configurationType);
        break;

      case "quasarpp":
        generateConfirmPopup(TuringForm, configurationType);
        break;

      case "stormseer":
        generateConfirmPopup(StormSeerForm, configurationType);
        break;

      case "automaticTicketResolverSaaS":
        generateConfirmPopup(ATRSaaSForm, configurationType);
        break;

      case "splunkClusterPlatform":
        generateConfirmPopup(SPLUCLUForm, configurationType);
        break;

      case "stack360":
        generateConfirmPopup(Stack360Form, configurationType);
        break;

      case "onPremiseService":
        generateConfirmPopup(OPSForm, configurationType);
        break;

      case "automationAnywhereLicenses":
        generateConfirmPopup(AALForm, configurationType);
        break;
      case "serviceIntegrator":
        generateConfirmPopup(SIForm, configurationType);
        break;
      case "ec2ClaudeCode":
        generateConfirmPopup(ECCForm, configurationType);
        break;
      case "agentMesh":
        generateConfirmPopup(AMForm, configurationType);
        break;
      case "cia":
        generateConfirmPopup(CIAForm, configurationType);
        break;
      case "dedicatedvirtualnetworksetup":
        // Skip generic confirmation for Dedicated VPC - use independent workflow
        break;
      case "bedrockplatform":
        generateConfirmPopup(CIAForm, configurationType);
        break;
      default:
        break;
    }
  };

  // the function to complete submission
  const handleSubmit = async () => {
    setOpenConfirmationPopup(false)
    setOpenValidationPopup(false)
    switch (routeName) {
      case "managedPlatform":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateMPSubmitData(
                generateNewForm(MPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(MPForm, appNameProjectId.managedPlatformId)
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateMPSubmitData(
                generateNewForm(MPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(MPForm, appNameProjectId.managedPlatformId)
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // OLD APPROVAL FLOW (fallback)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateMPSubmitData(
                generateNewForm(MPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(MPForm, appNameProjectId.managedPlatformId)
              )
            ) :
            submitForm(
              generateMPSubmitData(
                generateNewForm(MPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(MPForm, appNameProjectId.managedPlatformId)
              )
            );
        }
        break;

      case "dedicatedPlatform":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateDPSubmitData(
                generateNewForm(DPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(DPForm, appNameProjectId.dedicatedPlatformId)
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateDPSubmitData(
                generateNewForm(DPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(DPForm, appNameProjectId.dedicatedPlatformId)
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // OLD APPROVAL FLOW (fallback)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateDPSubmitData(
                generateNewForm(DPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(DPForm, appNameProjectId.dedicatedPlatformId)
              )
            ) :
            submitForm(
              generateDPSubmitData(
                generateNewForm(DPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(DPForm, appNameProjectId.dedicatedPlatformId)
              )
            );
        }
        break;
      case "pamktka":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateKQSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(KQForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(KQForm, appNameProjectId.pamktkaId)
            )
          )
          :
          submitForm(
            generateKQSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(KQForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(KQForm, appNameProjectId.pamktkaId)
            )
          );
        break;
      case "genWizardPlatform":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateGWLSubmitData(
                generateNewForm(GWLForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(GWLForm, appNameProjectId.genWizardPlatformId)
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateGWLSubmitData(
                generateNewForm(GWLForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(GWLForm, appNameProjectId.genWizardPlatformId)
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // OLD APPROVAL FLOW (fallback)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateGWLSubmitData(
                generateNewForm(GWLForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(GWLForm, appNameProjectId.genWizardPlatformId)
              )
            ) :
            submitForm(
              generateGWLSubmitData(
                generateNewForm(GWLForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(GWLForm, appNameProjectId.genWizardPlatformId)
              )
            );
        }
        break;

      case "adPlatform":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateADSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(ADForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(ADForm, appNameProjectId.adPlatformId)
            )
          )
          :
          submitForm(
            generateADSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(ADForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(ADForm, appNameProjectId.adPlatformId)
            )
          );
        break;

      case "windowsProvisioningPlatform":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateWPSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(WPForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(WPForm, appNameProjectId.windowsProvisioningPlatformId)
            )
          )
          :
          submitForm(
            generateWPSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(WPForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(WPForm, appNameProjectId.windowsProvisioningPlatformId)
            )
          );
        break;

      case "plainInstance":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generatePISubmitData(
                generateNewForm(PIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
                "myWizard AiOps"
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generatePISubmitData(
                generateNewForm(PIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
                "myWizard AiOps"
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // ORIGINAL APPROVAL PROCESS (FALLBACK)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generatePISubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(PIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
                "myWizard AiOps"
              )
            )
            :
            submitForm(
              generatePISubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(PIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
                "myWizard AiOps"
              )
            );
        }
        break;
      case "plainInstanceMcc":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS - MCC

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generatePISubmitData(
                generateNewForm(PIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
                "MCC"
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generatePISubmitData(
                generateNewForm(PIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
                "MCC"
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // ORIGINAL APPROVAL PROCESS (FALLBACK)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generatePISubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(PIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
                "MCC"
              )
            )
            :
            submitForm(
              generatePISubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(PIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
                "MCC"
              )
            );
        }
        break;

      case "pamInstance":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generatePAMSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(PAMForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(PAMForm, appNameProjectId.pamInstanceId),
              "pam"
            )
          ) :
          submitForm(
            generatePAMSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(PAMForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(PAMForm, appNameProjectId.pamInstanceId),
              "pam"
            )
          );
        break;

      case "utkmPlatform":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateUTKMSubmitData(
                generateNewForm(UTKMForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(UTKMForm, appNameProjectId.utkmPlatformId)
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateUTKMSubmitData(
                generateNewForm(UTKMForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(UTKMForm, appNameProjectId.utkmPlatformId)
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // OLD APPROVAL FLOW (fallback)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateUTKMSubmitData(
                generateNewForm(UTKMForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(UTKMForm, appNameProjectId.utkmPlatformId)
              )
            ) :
            submitForm(
              generateUTKMSubmitData(
                generateNewForm(UTKMForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(UTKMForm, appNameProjectId.utkmPlatformId)
              )
            );
        }
        break;

      case "automaticTicketResolver":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateATRSubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(ATRForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(
                  ATRForm,
                  appNameProjectId.automaticTicketResolverId
                )
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateATRSubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(ATRForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(
                  ATRForm,
                  appNameProjectId.automaticTicketResolverId
                )
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // Legacy approval process (original behavior)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateATRSubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(ATRForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(
                  ATRForm,
                  appNameProjectId.automaticTicketResolverId
                )
              )
            ) :
            submitForm(
              generateATRSubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(ATRForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(
                  ATRForm,
                  appNameProjectId.automaticTicketResolverId
                )
              )
            );
        }
        break;

      case "eventOpsPlatform":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateEventOpsSubmitData(
                generateNewForm(EventOpsForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(EventOpsForm, appNameProjectId.eventOpsId)
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateEventOpsSubmitData(
                generateNewForm(EventOpsForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(EventOpsForm, appNameProjectId.eventOpsId)
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // OLD APPROVAL FLOW (fallback)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateEventOpsSubmitData(
                generateNewForm(EventOpsForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(EventOpsForm, appNameProjectId.eventOpsId)
              )
            ) :
            submitForm(
              generateEventOpsSubmitData(
                generateNewForm(EventOpsForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(EventOpsForm, appNameProjectId.eventOpsId)
              )
            );
        }
        break;

      case "quasarpp":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateTuringSubmitData(
                generateNewForm(TuringForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(TuringForm, appNameProjectId.turingId)
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateTuringSubmitData(
                generateNewForm(TuringForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(TuringForm, appNameProjectId.turingId)
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // OLD APPROVAL FLOW (fallback)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateTuringSubmitData(
                generateNewForm(TuringForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(TuringForm, appNameProjectId.turingId)
              )
            ) :
            submitForm(
              generateTuringSubmitData(
                generateNewForm(TuringForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(TuringForm, appNameProjectId.turingId)
              )
            );
        }
        break;
      //genwizard agent
      case "genwizardAgent":
        await generateCipher(GAForm);
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS
          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            // submitFormWhitelistedUser(
            submitFormWhitelistedUser(
              generateGASubmitData(
                generateNewForm(GAForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(GAForm, appNameProjectId.genwizardAgentId)
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateGASubmitData(
                generateNewForm(GAForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(GAForm, appNameProjectId.genwizardAgentId)
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // OLD APPROVAL FLOW (fallback)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateGASubmitData(
                generateNewForm(GAForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(GAForm, appNameProjectId.genwizardAgentId)
              )
            ) :
            submitForm(
              generateGASubmitData(
                generateNewForm(GAForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(GAForm, appNameProjectId.genwizardAgentId)
              )
            );
        }
        break;
      //autonomous ops
      case "autonomousops":
        await generateCipher(AOPForm);
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS
          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateAOPSubmitData(
                generateNewForm(AOPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(AOPForm, appNameProjectId.autonomousOpsId)
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateAOPSubmitData(
                generateNewForm(AOPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(AOPForm, appNameProjectId.autonomousOpsId)
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // OLD APPROVAL FLOW (fallback)
          isUserApprovalWhitelisted ?
           submitFormWhitelistedUser(
              generateAOPSubmitData(
                generateNewForm(AOPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(AOPForm, appNameProjectId.autonomousOpsId)
              )
            ) :
            submitForm(
              generateAOPSubmitData(
                generateNewForm(AOPForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(AOPForm, appNameProjectId.autonomousOpsId)
              )
            );
        }
        break;
      case "stormseer":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateStormSeerSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(StormSeerForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(
                StormSeerForm,
                appNameProjectId.stormseerId
              )
            )
          ) :
          submitForm(
            generateStormSeerSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(StormSeerForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(
                StormSeerForm,
                appNameProjectId.stormseerId
              )
            )
          );
        break;
      case "automaticTicketResolverSaaS":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateATRSaaSSubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(ATRSaaSForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(
                  ATRSaaSForm,
                  appNameProjectId.automaticTicketResolverSaaSId
                )
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateATRSaaSSubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(ATRSaaSForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(
                  ATRSaaSForm,
                  appNameProjectId.automaticTicketResolverSaaSId
                )
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // Legacy approval process (original behavior)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateATRSaaSSubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(ATRSaaSForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(
                  ATRSaaSForm,
                  appNameProjectId.automaticTicketResolverSaaSId
                )
              )
            ) :
            submitForm(
              generateATRSaaSSubmitData(
                // create a JSON format payload that could accepted by controller by using a transfer function
                generateNewForm(ATRSaaSForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(
                  ATRSaaSForm,
                  appNameProjectId.automaticTicketResolverSaaSId
                )
              )
            );
        }
        break;

      case "splunkClusterPlatform":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateSplunkClusterSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(SPLUCLUForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(
                SPLUCLUForm,
                appNameProjectId.splunkClusterPlatformId
              )
            )
          ) :
          submitForm(
            generateSplunkClusterSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(SPLUCLUForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(
                SPLUCLUForm,
                appNameProjectId.splunkClusterPlatformId
              )
            )
          );
        break;

      case "stack360":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateStack360SubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(Stack360Form, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(Stack360Form, appNameProjectId.stack360Id)
            )
          ) :
          submitForm(
            generateStack360SubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(Stack360Form, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(Stack360Form, appNameProjectId.stack360Id)
            )
          );
        break;

      case "onPremiseService":
        submitFormNonApproval(
          generateOPSSubmitData(
            generateNewForm(OPSForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy
          )
        );
        break;

      case "automationAnywhereLicenses":
        submitFormNonApproval(
          generateAALSubmitData(
            generateNewForm(AALForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy
          )
        );
        break;
      case "serviceIntegrator":
        if (base.app.enhancedApprovalEnabled) {
          // ENHANCED 2-LEVEL APPROVAL PROCESS

          if (isUserApprovalWhitelisted) {
            // Whitelisted users bypass 2-level approval and go directly to provisioning
            submitFormWhitelistedUser(
              generateSISubmitData(
                generateNewForm(SIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(SIForm, appNameProjectId.serviceIntegratorId)
              )
            );
          } else {
            // Non-whitelisted users go through enhanced 2-level approval
            submitFormEnhancedApproval(
              generateSISubmitData(
                generateNewForm(SIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(SIForm, appNameProjectId.serviceIntegratorId)
              ),
              selectedApprover // Pass the selected L1 approver
            );
          }
        } else {
          // OLD APPROVAL FLOW (fallback)
          isUserApprovalWhitelisted ?
            submitFormWhitelistedUser(
              generateSISubmitData(
                generateNewForm(SIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(SIForm, appNameProjectId.serviceIntegratorId)
              )
            ) :
            submitForm(
              generateSISubmitData(
                generateNewForm(SIForm, configurationType),
                orderUId,
                orderItemUId,
                createdBy,
                generateUserOrder(SIForm, appNameProjectId.serviceIntegratorId)
              )
            );
        }
        break;
      case "ec2ClaudeCode":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateECCSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(ECCForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(ECCForm, appNameProjectId.ec2claudecodeId),
              "myWizard AiOps"
            )
          )
          :
          submitForm(
            generateECCSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(ECCForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(ECCForm, appNameProjectId.ec2claudecodeId),
              "myWizard AiOps"
            )
          );
        break;
      case "agentMesh":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateAMSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(AMForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(AMForm, appNameProjectId.agentMeshId),
              "myWizard AiOps"
            )
          )
          :
          submitForm(
            generateAMSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(AMForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(AMForm, appNameProjectId.agentMeshId),
              "myWizard AiOps"
            )
          );
        break;
      case "cia":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateCIASubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(CIAForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(CIAForm, appNameProjectId.ciaid),
              "myWizard AiOps"
            )
          )
          :
          submitForm(
            generateCIASubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(CIAForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(CIAForm, appNameProjectId.ciaid),
              "myWizard AiOps"
            )
          );
        break;
      case "dedicatedvirtualnetworksetup":
        // Independent Dedicated VPC submission
        handleDedicatedVPCSubmission();
        break;
      case "bedrockplatform":
        isUserApprovalWhitelisted ?
          submitFormWhitelistedUser(
            generateBRSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewFormBr(BRForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(BRForm, appNameProjectId.connectivityid),
              "myWizard AiOps"
            )
          )
          :
          submitForm(
            generateBRSubmitData(
              // create a JSON format payload that could accepted by controller by using a transfer function
              generateNewForm(BRForm, configurationType),
              orderUId,
              orderItemUId,
              createdBy,
              generateUserOrder(BRForm, appNameProjectId.bedrockid),
              "myWizard AiOps"
            )
          );
        break;
      default:
        break;
    }
  };

  // the function to validate submission
  const handleValidate = () => {
    // Don't show generic confirmation popup for Dedicated VPC
    if (routeName !== "dedicatedvirtualnetworksetup") {
      setOpenValidationPopup(true);
    }
    switch (routeName) {
      case "managedPlatform":
        validateForm(
          generateMPSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(MPForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(MPForm, appNameProjectId.managedPlatformId)
          )
        );
        break;

      case "dedicatedPlatform":
        validateForm(
          generateDPSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(DPForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(DPForm, appNameProjectId.dedicatedPlatformId)
          )
        );
        break;

      case "genWizardPlatform":
        validateForm(
          generateGWLSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(GWLForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(GWLForm, appNameProjectId.genWizardPlatformId)
          )
        );
        break;

      case "adPlatform":
        validateForm(
          generateADSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(ADForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(ADForm, appNameProjectId.adPlatformId)
          )
        );
        break;

      case "windowsProvisioningPlatform":
        validateForm(
          generateWPSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(WPForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(WPForm, appNameProjectId.windowsProvisioningPlatformId)
          )
        );
        break;

      case "plainInstance":
        validateForm(
          generatePISubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(PIForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
            "myWizard AiOps"
          )
        );
        break;
      case "plainInstanceMcc":
        validateForm(
          generatePISubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(PIForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(PIForm, appNameProjectId.plainInstanceId),
            "MCC"
          )
        );
        break;

      case "pamInstance":
        validateForm(
          generatePAMSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(PAMForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(PAMForm, appNameProjectId.pamInstanceId),
            "pam"
          )
        );
        break;

      case "utkmPlatform":
        validateForm(
          generateUTKMSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(UTKMForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(UTKMForm, appNameProjectId.utkmPlatformId),
          )
        );
        break;

      case "automaticTicketResolver":
        validateForm(
          generateATRSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(ATRForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(
              ATRForm,
              appNameProjectId.automaticTicketResolverId
            )
          )
        );
        break;
      //genwizard agent
      case "genwizardAgent":
        validateForm(
          generateGASubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(GAForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(
              GAForm,
              appNameProjectId.genwizardAgentId
            )
          )
        );
        break;
      //autonomous ops
      case "autonomousops":
        validateForm(
          generateAOPSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(AOPForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(
              AOPForm,
              appNameProjectId.autonomousOpsId
            )
          )
        );
        break;

      case "eventOpsPlatform":
        validateForm(
          generateEventOpsSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(EventOpsForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(
              EventOpsForm,
              appNameProjectId.eventOpsId
            )
          )
        );
        break;

      case "quasarpp":
        validateForm(
          generateTuringSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(TuringForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(
              TuringForm,
              appNameProjectId.turingId
            )
          )
        );
        break;

      case "stormseer":
        validateForm(
          generateStormSeerSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(StormSeerForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(
              StormSeerForm,
              appNameProjectId.stormseerId
            )
          )
        );
        break;

      case "automaticTicketResolverSaaS":
        validateForm(
          generateATRSaaSSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(ATRSaaSForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(
              ATRSaaSForm,
              appNameProjectId.automaticTicketResolverSaaSId
            )
          )
        );
        break;

      case "splunkClusterPlatform":
        validateForm(
          generateSplunkClusterSubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(SPLUCLUForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(
              SPLUCLUForm,
              appNameProjectId.splunkClusterPlatformId
            )
          )
        );
        break;

      case "stack360":
        validateForm(
          generateStack360SubmitData(
            // create a JSON format payload that could accepted by controller by using a transfer function
            generateNewForm(Stack360Form, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(Stack360Form, appNameProjectId.stack360Id)
          )
        );
        break;

      case "onPremiseService":
        validateForm(
          generateOPSSubmitData(
            generateNewForm(OPSForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy
          )
        );
        break;

      case "automationAnywhereLicenses":
        validateForm(
          generateAALSubmitData(
            generateNewForm(AALForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy
          )
        );
        break;
      case "pamktka":
        validateForm(
          generateKQSubmitData(
            generateNewForm(KQForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(KQForm, appNameProjectId.pamktkaId)
          )
        );
        break;
      case "serviceIntegrator":
        validateForm(
          generateSISubmitData(
            generateNewForm(SIForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(SIForm, appNameProjectId.serviceIntegratorId)
          )
        );
        break;
      case "ec2ClaudeCode":
        validateForm(
          generateECCSubmitData(
            generateNewForm(ECCForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(ECCForm, appNameProjectId.ec2claudecodeId)
          )
        );
        break;
      case "agentMesh":
        validateForm(
          generateAMSubmitData(
            generateNewForm(AMForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(AMForm, appNameProjectId.agentMeshId)
          )
        );
        break;
      case "cia":
        validateForm(
          generateCIASubmitData(
            generateNewForm(CIAForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(CIAForm, appNameProjectId.ciaid)
          )
        );
        break;
      case "dedicatedvirtualnetworksetup":
        // Skip generic validation - Dedicated VPC uses independent workflow
        break;
      case "bedrockplatform":
        validateForm(
          generateCIASubmitData(
            generateNewForm(CIAForm, configurationType),
            orderUId,
            orderItemUId,
            createdBy,
            generateUserOrder(CIAForm, appNameProjectId.ciaid)
          )
        );
        break;
      default:
        break;
    }
  };


  // get value of projectId, productUId, customerEnterpriseID and sapContractID, and combine them together as userOrder
  const generateUserOrder = (form, productUId) => {
    const userOrder = [
      form.DMSId === "" ? form.DomainContextRoot : form.DMSId,
      productUId,
      createdBy,
      form.SAPContractID === "" ? form.DomainContextRoot : form.SAPContractID,
    ].join("");
    return userOrder;
  };

  // create function that guide to selected products
  const renderProduct = () => {
    switch (routeName) {
      case undefined:
        return <StandardOrder />;
      case "managedPlatform":
        return (
          <ManagedPlatform
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "dedicatedPlatform":
        return (
          <DedicatedPlatform
            createdBy={createdBy}
            setIsAllValid={setIsAllValid}
            selectedEnvironment={selectedEnvironment}
            getSelectedEnvironment={getSelectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            getServiceEndDate={getServiceEndDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "utkmPlatform":
        return (
          <UTKMPlatform
            createdBy={createdBy}
            setIsAllValid={setIsAllValid}
            selectedEnvironment={selectedEnvironment}
            getSelectedEnvironment={getSelectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            getServiceEndDate={getServiceEndDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "genWizardPlatform":
        return (
          <GenWizardPlatform
            createdBy={createdBy}
            setIsAllValid={setIsAllValid}
            selectedEnvironment={selectedEnvironment}
            getSelectedEnvironment={getSelectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            getServiceEndDate={getServiceEndDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "adPlatform":
        return (
          <ADPlatform
            createdBy={createdBy}
            setIsAllValid={setIsAllValid}
            selectedEnvironment={selectedEnvironment}
            getSelectedEnvironment={getSelectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            getServiceEndDate={getServiceEndDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "windowsProvisioningPlatform":
        return (
          <WindowsProvisioningPlatform
            createdBy={createdBy}
            setIsAllValid={setIsAllValid}
            selectedEnvironment={selectedEnvironment}
            getSelectedEnvironment={getSelectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            getServiceEndDate={getServiceEndDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "plainInstance":
        return (
          <PlainInstance
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="CAM"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "plainInstanceMcc":
        return (
          <PlainInstance
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="MCC"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "pamInstance":
        return (
          <PamInstance
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="pam"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "onPremiseService":
        return (
          <OnPremiseService
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            formClickSubmit={submitFormClick}
          />
        );

      case "automaticTicketResolver":
        return (
          <AutomaticTicketResolver
            createdBy={createdBy}
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );

      case "eventOpsPlatform":
        return (
          <EventOps
            createdBy={createdBy}
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );

      case "quasarpp":
        return (
          <Turing
            createdBy={createdBy}
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "genwizardAgent":
        if (history.location.state.GAVersion === "4.2.0") {
          return (
            <GenWizardAgentBeta
              createdBy={createdBy}
              selectedEnvironment={selectedEnvironment}
              minDate={minDate}
              maxDate={maxDate}
              serviceEndDateValue={serviceEndDateValue}
              isServiceEndDateInvalid={isServiceEndDateInvalid}
              getSelectedEnvironment={getSelectedEnvironment}
              getServiceEndDate={getServiceEndDate}
              getNotesValue={getNotesValue}
              notesValidations={notesValidations}
              classes={classes}
              setIsAllValid={setIsAllValid}
              getSelectedClientname={getSelectedClientname}
              getSAPContractIDValue={getSAPContractIDValue}
              selectedClientname={selectedClientname}
              sapContractIdValue={sapContractIdValue}
              formClickSubmit={submitFormClick}
            />
          );
        } else {
          return (
            <GenWizardAgent
              createdBy={createdBy}
              selectedEnvironment={selectedEnvironment}
              minDate={minDate}
              maxDate={maxDate}
              serviceEndDateValue={serviceEndDateValue}
              isServiceEndDateInvalid={isServiceEndDateInvalid}
              getSelectedEnvironment={getSelectedEnvironment}
              getServiceEndDate={getServiceEndDate}
              getNotesValue={getNotesValue}
              notesValidations={notesValidations}
              classes={classes}
              setIsAllValid={setIsAllValid}
              getSelectedClientname={getSelectedClientname}
              getSAPContractIDValue={getSAPContractIDValue}
              selectedClientname={selectedClientname}
              sapContractIdValue={sapContractIdValue}
              formClickSubmit={submitFormClick}
            />
          );
        }
      case "stormseer":
        return (
          <StormSeer
            createdBy={createdBy}
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );

      case "automaticTicketResolverSaaS":
        return (
          <AutomaticTicketResolverSaaS
            createdBy={createdBy}
            classes={classes}
            setIsAllValid={setIsAllValid}
          />
        );
      case "splunkClusterPlatform":
        return (
          <SplunkCluster
            createdBy={createdBy}
            setIsAllValid={setIsAllValid}
            selectedEnvironment={selectedEnvironment}
            getSelectedEnvironment={getSelectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            getServiceEndDate={getServiceEndDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "stack360":
        return (
          <Stack360
            createdBy={createdBy}
            setIsAllValid={setIsAllValid}
            selectedEnvironment={selectedEnvironment}
            getSelectedEnvironment={getSelectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            getServiceEndDate={getServiceEndDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            formClickSubmit={submitFormClick}
          />
        );
      case "automationAnywhereLicenses":
        return (
          <AutomationAnywhereLicenses
            createdBy={createdBy}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            formClickSubmit={submitFormClick}
          />
        );
      case "pamktka":
        return (
          <Pamktka
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="pam"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "serviceIntegrator":
        return (
          <ServiceIntegrator
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="CAM"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "ec2ClaudeCode":
        return (
          <Ec2ClaudeCode
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="CAM"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "agentMesh":
        return (
          <AgentMesh
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="CAM"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "cia":
        return (
          <Cia
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="CAM"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}
          />
        );
      case "dedicatedvirtualnetworksetup":
        return (
          <DedicatedVirtualNetworkSetup
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="CAM"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick2}
          />
        );
      case "BedrockPlatform":
        return (
          <Bedrock
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="CAM"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick3}

          />
        );
      case "autonomousops":
        return (
          <AutonomousOps
            createdBy={createdBy}
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            vendorName="CAM"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}

          />
        );
      case "reverseEngineering":
        return (
          <ReverseEngineering
            selectedEnvironment={selectedEnvironment}
            minDate={minDate}
            maxDate={maxDate}
            serviceEndDateValue={serviceEndDateValue}
            isServiceEndDateInvalid={isServiceEndDateInvalid}
            // serviceEndDateValid={serviceEndDateValid}
            getSelectedEnvironment={getSelectedEnvironment}
            getServiceEndDate={getServiceEndDate}
            getNotesValue={getNotesValue}
            notesValidations={notesValidations}
            classes={classes}
            setIsAllValid={setIsAllValid}
            createdBy={createdBy}
            vendorName="CAM"
            getSelectedClientname={getSelectedClientname}
            getSAPContractIDValue={getSAPContractIDValue}
            selectedClientname={selectedClientname}
            sapContractIdValue={sapContractIdValue}
            formClickSubmit={submitFormClick}

          />
        );
      default:

        return <AppStepper classes={classes} />;
    }
  };

  var approvers = [];
  if (approversData.length !== 0) {
    if (configurationType === "full") {
      approvers = approversData[0]["ApproversFull"].split(";");
    } else {
      if (
        selectedForm.TeamName === "GTAAD" &&
        routeName !== "adPlatform"
      ) {
        if (approversGtad.length !== 0)
          approvers = approversGtad[0]["ApproversQuick"].split(";");
      } else {
        approvers = approversData[0]["ApproversQuick"].split(";");
      }
    }
  }

  // Choose approvers data based on enhanced approval flag
  const currentApproversData = base.app.enhancedApprovalEnabled ? approversEnhancedData : approversData;

  var approvers = [];

  if (currentApproversData && Object.keys(currentApproversData).length !== 0) {
    if (base.app.enhancedApprovalEnabled) {
      // Enhanced mode: currentApproversData is an object
      const approversDataObj = currentApproversData;
      // ENHANCED APPROVAL MODE: Use level1_approvers structure
      if (configurationType === "full") {
        if (approversDataObj["level1_approvers"] && approversDataObj["level1_approvers"].length > 0) {
          // Handle new API format where level1_approvers is a direct array of emails
          if (Array.isArray(approversDataObj["level1_approvers"]) && typeof approversDataObj["level1_approvers"][0] === 'string' && !approversDataObj["level1_approvers"][0].includes(';')) {
            approvers = approversDataObj["level1_approvers"];
          } else {
            // Legacy format where first element contains semicolon-separated emails
            approvers = approversDataObj["level1_approvers"][0].split(";");
          }
        }
      } else {
        if (
          selectedForm.TeamName === "GTAAD" &&
          routeName !== "adPlatform"
        ) {
          if (approversGtad && Object.keys(approversGtad).length !== 0 && approversGtad["level1_approvers"] && approversGtad["level1_approvers"].length > 0) {
            // Handle new API format where level1_approvers is a direct array of emails
            if (Array.isArray(approversGtad["level1_approvers"]) && typeof approversGtad["level1_approvers"][0] === 'string' && !approversGtad["level1_approvers"][0].includes(';')) {
              approvers = approversGtad["level1_approvers"];
            } else {
              // Legacy format where first element contains semicolon-separated emails
              approvers = approversGtad["level1_approvers"][0].split(";");
            }
          }
        } else {
          if (approversDataObj["level1_approvers"] && approversDataObj["level1_approvers"].length > 0) {
            // Handle new API format where level1_approvers is a direct array of emails
            if (Array.isArray(approversDataObj["level1_approvers"]) && typeof approversDataObj["level1_approvers"][0] === 'string' && !approversDataObj["level1_approvers"][0].includes(';')) {
              approvers = approversDataObj["level1_approvers"];
            } else {
              // Legacy format where first element contains semicolon-separated emails
              approvers = approversDataObj["level1_approvers"][0].split(";");
            }
          }
        }
      }
    } else {
      // Legacy mode: currentApproversData is an array
      if (currentApproversData.length > 0) {
        const approversDataObj = currentApproversData[0];

        // LEGACY APPROVAL MODE: Use ApproversQuick and ApproversFull structure
        if (configurationType === "full") {
          if (approversDataObj["ApproversFull"] && approversDataObj["ApproversFull"].length > 0) {
            approvers = approversDataObj["ApproversFull"].split(";");
          }
        } else {
          if (
            selectedForm.TeamName === "GTAAD" &&
            routeName !== "adPlatform"
          ) {
            if (approversGtad && Object.keys(approversGtad).length !== 0 && approversGtad["ApproversQuick"] && approversGtad["ApproversQuick"].length > 0)
              approvers = approversGtad["ApproversQuick"].split(";");
          } else {
            if (approversDataObj["ApproversQuick"] && approversDataObj["ApproversQuick"].length > 0) {
              approvers = approversDataObj["ApproversQuick"].split(";");
            }
          }
        }
      }
    }
  }

  useEffect(() => {
    if (selectedForm.OpenAI === true || selectedForm.OpenAI === "True" && routeName !== "quasarpp") {
      setSelectedForm((prevState) => ({
        ...prevState,
        AppsIntegration_OpenAI: ["ATR", "Quasarpp"], // Update AppsIntegration
      }));
    }
  }, [selectedForm.OpenAI]); // Do not include setSelectedForm here
  const [selectedApprover, setSelectedApprover] = useState("");

  const handleApproverChange = (event, value) => {
    setSelectedApprover(value);
  }
  //generate encryption
  const generateCipher = async (form) => {
    const assetName = form['AaamPlatformType'];
    if (assetName === "GenWizard AiOps Genwizard Agent") {
      //create loading
      setgenwiz({
        appName: 'gwLoading',
        config: {
          stateFunction: setgenwiz,
          text: 'Please wait',
        }
      });
      const configCCaas = form['CCAASConfig'];
      const configGWtool = form['Genwizard_Tool'];
      const configSAPLLM = form['SAPAgentLLMConfig'];
      const toEncrypt = ['GCPAccessKey', 'S3AccessKey', 'SMTPPassword'];
      for (const [key, val] of Object.entries(configCCaas)) {
        if (toEncrypt.includes(key) && val !== "") {
          const valueReturn = await hideSensitiveData(val);
          if (valueReturn) {
            form.CCAASConfig[key] = valueReturn.encryptedValue;
          }
        }
      }

      for (const item of Object.entries(configGWtool)) {
        const [ik, iv] = item;
        for (const [key, val] of Object.entries(iv)) {
          if (['PAT', 'Password'].includes(key) && val !== "") {
            const valueReturn = await hideSensitiveData(val);
            if (valueReturn) {
              form['Genwizard_Tool'][ik][key] = valueReturn.encryptedValue;
            }
          }
        }
      }
      for (const [key, val] of Object.entries(configSAPLLM)) {
        if (['Arn', 'AccessKey'].includes(key) && val !== "") {
          const valueReturn = await hideSensitiveData(val);
          if (valueReturn) {
            form.SAPAgentLLMConfig[key] = valueReturn.encryptedValue;
          }
        }
      }
    }
    // NEW: Autonomous Ops — encrypts every masked field across the AOP
    if (assetName === "GenWizard AiOps Autonomous Ops") {
      const AOP_SECRETS = {
        IMConfig: ["Password"],
        AMConfig: ["APIKey"],
        TicketSourceConfig: ["Password"],
        ServiceNowConfig: ["Password"],
        SplunkConfig: ["Password", "Token"],
        CMDBLiteConfig: ["Password"],
        DatadogConfig: ["Password"],
        DynatraceConfig: ["Password"],
        ElasticSearchConfig: ["Password"],
        SLOConfig: ["Password"],
        VenafiConfig: ["APIKey"],
        AWXConfig: ["Password"],
      };
      for (const [configKey, fields] of Object.entries(AOP_SECRETS)) {
        const configObj = form[configKey];
        if (!configObj) continue;
        for (const field of fields) {
          const val = configObj[field];
          if (typeof val !== "string" || val === "") continue;
          const valueReturn = await hideSensitiveData(val);
          if (valueReturn) form[configKey][field] = valueReturn.encryptedValue;
        }
      }
    }

    setgenwiz({});
    setEncrypt(true);
  }

  // Calculate the computed value for the selected platform based on the tier and application
  const computedValues = useMemo(() => {
    const { Tier, AppsIntegration, OpenAI, AppsIntegration_OpenAI, AaamPlatformType } = selectedForm;

    if (Tier) {
      const mapping = priceConfig.tierToApplicationProvisionMapping[Tier];

      // If AppsIntegration is available, calculate total
      let total = 0;
      let multiplier = 1

      if (AaamPlatformType === "myWizard AiOps AD Platform" || selectedForm.KMApps === "KlewerGenAi-QuasarGenAi-Quasarpp") {
        multiplier = 2
      }

      if (AppsIntegration && AppsIntegration.length > 0 || AppsIntegration_OpenAI && AppsIntegration_OpenAI.length > 0) {
        const selectedApps = AppsIntegration ? AppsIntegration : AppsIntegration_OpenAI;
        total = selectedApps.reduce((sum, app) => {
          let price = Number(mapping[app].replace("$", ""));
          if (app === "AD") {
            price *= 2;
          }
          return sum + price
        }, 0);

      } else {
        // If AppsIntegration is not available, use the first app's mapping value
        total = Number(mapping[Object.keys(mapping)[0]].replace("$", ""));
      }

      total *= multiplier;

      // Check if OpenAI is true (either boolean true or string "True")
      const isOpenAIActive = OpenAI === true || OpenAI === "True" ? true : false;

      // If OpenAI is true, double the total value
      const doubledTotal = total;
      const Totalvalue = `$${doubledTotal}`;
      const TierValue = mapping[AppsIntegration && AppsIntegration.length > 0 ? AppsIntegration[0] : Object.keys(mapping)[0]];
      const AppsIntegrationLength = (AppsIntegration ? AppsIntegration.includes("AD") ? AppsIntegration.length + 1 : AppsIntegration.length : 1);

      return {
        Totalvalue,
        AppsIntegrationLength, // Default to 1 if no AppsIntegration
        TierValue,
      };
    }
  }, [selectedForm, priceConfig.tierToApplicationProvisionMapping]);
  return (
    <>
      <div>
        {!isFormSubmittedSuccessful && !isFormSubmittedFailed && !isSubmitFormLoading && (
          <PageWrapper>
            <ConfigurationWrapper>
              <StepOnePaper>
                {createdBy &&
                  <Fragment>
                    {renderProduct()}
                    {/* {activeStep === 2 ?
                      <ButtonWrapper style={{ marginTop: "-5%" }}>
                        <PrimaryButton
                          onClick={isFinished && isAllValid ? handleConfirm : handleClick}
                          disabled={
                            isFinished &&
                            isAllValid &&
                            !isServiceEndDateInvalid &&
                            notesValidations.maxLength
                          }
                          className={classes.FuiPrimaryButton}
                          label={"Submit"}
                        />
                      </ButtonWrapper>
                      :
                      " "
                    } */}

                  </Fragment>}
              </StepOnePaper>

            </ConfigurationWrapper>
          </PageWrapper>
        )}
        {(isFormSubmittedSuccessful) &&
          <>
            {!showOrderInfo ?
              <SubmitSuccess orderItemUId={orderItemUId} approverName={selectedApprover} requester={createdBy} isUserApprovalWhitelisted={isUserApprovalWhitelisted} routeName={routeName} />
              :
              <SubmitInternal orderId={orderId} />
            }
          </>
        }
        {isFormSubmittedFailed && (
          <SubmitFailed orderItemUId={orderItemUId} />
        )}


        <StyledSnackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          open={open}
          onClose={handleClose}
          autoHideDuration={7000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          style={{ width: "max-content" }}
          message={
            <StyledSpan id="message-id">
              SUBMIT FAILED: Please review the form and resolve any validation errors before submitting.
            </StyledSpan>
          }
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
        {openConfirmationPopup && routeName !== "dedicatedvirtualnetworksetup" && (
          <CommonDialog
            open={openConfirmationPopup}
            onClose={() => {
              setOpenConfirmationPopup(false);
              setAcknowledgementData(null);
              setAcknowledgementError(null);
              setAgreementAccepted(false);
            }}
            title={"Review Order Details"}
            dialogType={"fui"}
            // textContent={"Thank you for choosing our service! Before you submit your request, please take a moment to review the order details below. Ensuring accuracy now will help prevent any issues later on."}
            textContent={
              <Grid container spacing={2} style={{ maxWidth: 900, margin: "auto" }}>
                <Grid item xs={7}>
                  <Card style={{ height: "100%" }}>
                    <CardContent>
                      <p style={{ fontWeight: "400" }}>Before you submit your request, please take a moment to review the order details below. Ensuring accuracy now will help prevent any issues later on.</p>
                      <Table>
                        <TableBody>{selectedForm.SAPContractID &&
                          <TableRow>
                            <BoldTableCell>SAP Contract ID</BoldTableCell>
                            <TableCell>{selectedForm.SAPContractID}</TableCell>
                          </TableRow>
                        }{selectedForm.ClientName &&
                          <TableRow>
                            <BoldTableCell>Client Name</BoldTableCell>
                            <TableCell>{selectedForm.ClientName}</TableCell>
                          </TableRow>
                          }{selectedForm.EndToEndUId &&
                            <TableRow>
                              <BoldTableCell>End To End ID</BoldTableCell>
                              <TableCell>{selectedForm.EndToEndUId}</TableCell>
                            </TableRow>}
                          <TableRow>
                            <BoldTableCell>Project Name</BoldTableCell>
                            <TableCell>{selectedForm.ProjectName}</TableCell>
                          </TableRow>
                          <TableRow>
                            <BoldTableCell>WBSE Code</BoldTableCell>
                            <TableCell>{selectedForm.WBSEcode}</TableCell>
                          </TableRow>
                          <TableRow>
                            <BoldTableCell>Domain Context Root</BoldTableCell>
                            <TableCell>{selectedForm.DomainContextRoot === "" ? "NA" : selectedForm.DomainContextRoot}</TableCell>
                          </TableRow>
                          <TableRow>
                            <BoldTableCell>Admin Distribution Group</BoldTableCell>
                            <TableCell>{selectedForm.AdminDistributionGroup === "" || selectedForm.AdminDistributionGroup === undefined ? "NA" : selectedForm.AdminDistributionGroup}</TableCell>
                          </TableRow>
                          <TableRow>
                            <BoldTableCell>Environment</BoldTableCell>
                            <TableCell>{selectedForm.Environment}</TableCell>
                          </TableRow>
                          <TableRow>
                            <BoldTableCell>GDPR</BoldTableCell>
                            <TableCell>{selectedForm.GDPR === "" || selectedForm.GDPR === undefined ? "NA" : selectedForm.GDPR.toUpperCase()}</TableCell>
                          </TableRow>
                          <TableRow>
                            <BoldTableCell>Deployment Region</BoldTableCell>
                            <TableCell>{selectedForm.DeploymentRegion === "" || selectedForm.DeploymentRegion === undefined ? "NA" : selectedForm.DeploymentRegion.toUpperCase()}</TableCell>
                          </TableRow>
                          <TableRow>
                            <BoldTableCell>Instance Type</BoldTableCell>
                            <TableCell>{selectedForm.InstanceType}</TableCell>
                          </TableRow>
                          <TableRow>
                            <BoldTableCell>Notes</BoldTableCell>
                            <TableCell>{selectedForm.RequestNotes}</TableCell>
                          </TableRow>
                          {!((routeName === "quasarpp" || routeName === "automaticTicketResolver" || routeName === "genwizardAgent") && selectedForm.InstanceType === "Container") &&
                            <TableRow>
                              <BoldTableCell>Tier</BoldTableCell>
                              <TableCell>{selectedForm.Tier === "" || selectedForm.Tier === undefined ? "NA" : selectedForm.Tier}</TableCell>
                            </TableRow>}
                          {selectedForm.AaamPlatformType === "GenWizard AD Platform" && selectedForm.AppsIntegration && selectedForm.AppsIntegration.length > 0 && (
                            <TableRow>
                              <BoldTableCell>Application provisioning</BoldTableCell>
                              <TableCell>{
                                (() => {
                                  if (selectedForm.AppsIntegration.length === 0) return ""
                                  let appsNames = null;
                                  selectedForm.AppsIntegration.map((itemX) => {
                                    if (itemX === 'Quasarpp')
                                      appsNames = appsNames ? appsNames + ',KM' : "KM"
                                    if (itemX === 'ATR')
                                      appsNames = appsNames ? appsNames + ',AR' : "AR"
                                    if (itemX === 'AD')
                                      appsNames = appsNames ? appsNames + ',AD' : "AD"
                                  })
                                  return appsNames;
                                })()
                              }</TableCell>

                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={5} justifyContent="center" alignItems="center">
                  <Card style={{ backgroundColor: "#7500C0", color: "white", height: "100%", padding: 2, display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                    <CardContent style={{ textAlign: "center" }}>
                      <Typography variant="h6" marginTop="50px" marginBottom="50px">
                        {
                          routeName === "quasarpp" ? "Knowledge Manager" :
                            routeName === "automaticTicketResolver" ? "Auto Resolver" :
                              routeName === "pamktka" ? "Knowledge Transition & Knowledge Assistant" :
                                routeName === 'utkmPlatform' ? <>GenWizard AiOps<br />KT & KA<br />Platform</> :
                                  routeName === 'eventOpsPlatform' ? <>GenWizard AiOps<br />Event Operations<br />Platform</> :
                                    selectedForm.AaamPlatformType ? selectedForm.AaamPlatformType.replace("myWizard", "GenWizard") :
                                      selectedForm.ChooseTheExistingInstance.replace("myWizard", "GenWizard")
                        }
                      </Typography>

                      {/* --- container-based flat rate, no tier shown, no computation --- */}
                      {(routeName === "quasarpp" || routeName === "automaticTicketResolver" || routeName === "genwizardAgent") ? (
                        <Box
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            borderRadius: "50%",
                            width: 200,
                            height: 200,
                            margin: "auto",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant="h5">Minimum</Typography>
                          <Typography variant="h5">$790</Typography>
                          <Typography variant="body2">/ month</Typography>
                        </Box>
                      ) : selectedForm.Tier !== "" ? (
                        <Box
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            borderRadius: "50%",
                            width: 200,
                            height: 200,
                            margin: "auto",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant="h5">{selectedForm.Tier === "" ? "NA" : selectedForm.Tier.charAt(0).toUpperCase() + selectedForm.Tier.slice(1)}</Typography>
                          {/* <Typography variant="body2">
                          {priceConfig.priceToTier[selectedForm.Tier] && priceConfig.priceToTier[selectedForm.Tier].price
                            ? `(${priceConfig.priceToTier[selectedForm.Tier].price}/month)`
                            : ""}
                        </Typography> */}
                          <Typography variant="body2">
                            {selectedForm.AaamPlatformType === "myWizard AiOps AD Platform" || selectedForm.KMApps === "KlewerGenAi-QuasarGenAi-Quasarpp" ? `2 * ${computedValues.TierValue}`
                              : selectedForm.AaamPlatformType === "myWizard AiOps Auto Resolver Platform" && (selectedForm.OpenAI === true || selectedForm.OpenAI === "True") ? `2 * ${computedValues.TierValue}` :
                                computedValues && computedValues.AppsIntegrationLength && computedValues.TierValue && computedValues.Totalvalue
                                  ? `${computedValues.AppsIntegrationLength} * ${computedValues.TierValue} =`
                                  : ""}
                          </Typography>
                          <Typography variant="h5">
                            {computedValues && computedValues.Totalvalue ? computedValues.Totalvalue : ""}
                          </Typography>
                          <Typography variant="body2">
                            / month
                          </Typography>
                        </Box>
                      ) : ""}
                    </CardContent>
                  </Card>
                </Grid>

                {/* Dynamic Agreement Container */}
                <div style={{
                  padding: '16px',
                  borderRadius: '6px',
                  border: '1px solid #e5e7eb',
                  backgroundColor: 'rgba(0, 0, 0, 0.02)',
                  marginTop: '20px'
                }}>
                  {/* Agreement Title */}
                  <div style={{
                    fontWeight: 700,
                    marginBottom: '16px',
                    color: '#1a202c',
                    fontSize: '15px'
                  }}>
                    {configurationType === 'quick' ? 'Internal Order Acknowledgement' : 'Client Order Acknowledgement'} <span style={{ color: '#6b7280' }}>*</span>
                  </div>

                  {/* Loading State */}
                  {acknowledgementLoading && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '20px'
                    }}>
                      <div style={{ marginRight: '8px' }}>Loading acknowledgemnt...</div>
                    </div>
                  )}

                  {/* Error State */}
                  {acknowledgementError && (
                    <div style={{
                      padding: '16px',
                      backgroundColor: '#ffebee',
                      borderRadius: '4px',
                      border: '1px solid #ffcdd2',
                      marginBottom: '16px'
                    }}>
                      <div style={{ color: '#d32f2f', fontSize: '14px' }}>
                        Failed to load acknowledgement message. Please try again.
                      </div>
                    </div>
                  )}

                  {/* Dynamic Acknowledgement Message */}
                  {acknowledgementData && !acknowledgementLoading && (
                    <>
                      <div style={{
                        backgroundColor: 'transparent',
                        padding: '0 0 16px 0',
                        marginBottom: '16px',
                        borderBottom: '1px solid #e5e7eb'
                      }}>
                        <div style={{
                          color: '#6b7280',
                          lineHeight: '1.7',
                          fontSize: '14px',
                          fontWeight: '400'
                        }}>
                          {formatAcknowledgementText(acknowledgementData.message)}
                        </div>
                      </div>

                      {/* Acknowledgement Checkbox */}
                      <FormControlLabel
                        style={{
                          marginLeft: '10px',
                          alignItems: 'center',
                          margin: 0,
                          display: 'flex'
                        }}
                        control={
                          <Checkbox
                            checked={agreementAccepted}
                            onChange={(e) => setAgreementAccepted(e.target.checked)}
                            style={{
                              color: '#7500C0',
                              padding: '6px'
                            }}
                          />
                        }
                        label={
                          <Typography variant="body2" style={{
                            fontSize: '14px',
                            fontWeight: 500,
                            color: '#495057'
                          }}>
                            I accept the terms stated above and agree to proceed.
                          </Typography>
                        }
                      />
                    </>
                  )}
                </div>
              </Grid>
            }
            dialogActions={
              <DialogActions >
                <DeclineButton
                  onClick={() => {
                    setOpenConfirmationPopup(false);
                    setAcknowledgementData(null);
                    setAcknowledgementError(null);
                    setAgreementAccepted(false);
                  }}
                  label={"No"}
                  disabled={false}
                />
                <AcceptButton
                  // onClick={() => handleSubmit()}
                  onClick={() => {
                    if (routeName === "dedicatedvirtualnetworksetup") {
                      // Independent Dedicated VPC submission
                      handleDedicatedVPCSubmission();
                    } else if (routeName === "onPremiseService" || routeName === "automationAnywhereLicenses" || isUserApprovalWhitelisted) {
                      handleSubmit();
                    } else {
                      handleValidate();
                    }
                  }}
                  disabled={!agreementAccepted}
                  label={"Yes"}
                />
              </DialogActions>
            }
          ></CommonDialog >
        )}
        {
          openValidationPopup && (
            <CommonDialog
              open={openValidationPopup}
              onClose={() => setOpenValidationPopup(false)}
              // title={!isFormValidationSuccessful ? "Validating Order Details" : "Add Approver"}
              title={(() => {
                if (!isFormValidationSuccessful) {
                  return "Validating Order Details"
                } else if (validationData) {
                  if (validationData.validation === "OK") {
                    return "Add Approver"
                  } else {
                    return "Validation Failed"
                  }
                } else {
                  return ""
                }
              })()}
              dialogType={"fui"}
              textContent={
                <div>
                  {!isFormValidationSuccessful ? (
                    <div>
                      <div
                        style={{
                          paddingTop: "8%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <CircularProgress size={40} />
                      </div>
                      <div
                        style={{
                          paddingTop: "8%",
                          paddingBottom: "8%",
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        <h4>Please wait.... </h4>
                        <p style={{ fontWeight: "400" }}>Validating your request</p>
                        <p style={{ lineHeight: "0.1px", fontWeight: "400" }}><i>This may take up to a minute....</i></p>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        paddingBottom: "5%",
                      }}
                    >
                      {(() => {
                        if (validationData.validation === "OK") {
                          return (
                            <div>
                              <p style={{ fontWeight: "500" }}>Your request has been successfully validated!</p>
                              <p style={{ fontWeight: "400" }}>Please select an approver from the dropdown to proceed with your order request.</p>
                              {isLoading || !currentApproversData || Object.keys(currentApproversData).length === 0 || approvers.length === 0 ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px",
                                  }}
                                >
                                  <CircularProgress size={20} style={{ marginRight: "10px" }} />
                                  <span>Loading approvers...</span>
                                </div>
                              ) : (
                                <Autocomplete
                                  id="country-select-demo"
                                  options={approvers.sort()}
                                  onChange={handleApproverChange}
                                  autoHighlight
                                  getOptionLabel={(option) => option}
                                  renderOption={(option) => (
                                    <React.Fragment>
                                      {option}
                                    </React.Fragment>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Select Approver"
                                      variant="outlined"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password',
                                      }}
                                    />
                                  )}
                                />
                              )}
                            </div>
                          )
                        } else if (validationData.validation === "ERROR") {
                          return (
                            <div>
                              <p><b>We regret to inform you that order validation has failed!</b></p>
                              <p style={{ color: "red" }}>ERROR: {validationData.responseDescription.toUpperCase()}</p>
                              <p>Please review the form again and try submitting it once more.</p>
                            </div>
                          )
                        } else {
                          return (
                            <div>
                              <p><b>We regret to inform you that order validation has failed due to an intermittent issue!</b></p>
                              <p>Please try again after some time. If the problem persists, please contact our support team for assistance.</p>
                            </div>
                          )
                        }
                      })()}
                    </div>
                  )}
                </div>
              }
              dialogActions={
                <DialogActions >
                  {isLoading ? "" : validationData && validationData.validation == "OK" ?
                    <AcceptButton
                      disabled={selectedApprover === "" ? true : false}
                      onClick={() => handleSubmit()}
                      // onClick={() => handleValidate()}
                      label={"Submit"}
                    /> :
                    <Button
                      style={{ background: "#7500C0", color: "#FFF" }}
                      onClick={handleClose}
                    >
                      OK
                    </Button>}
                </DialogActions>
              }
            ></CommonDialog>
          )
        }
      </div >
      {isSubmitFormLoading ? <div>
        < div
          style={{
            paddingTop: "8%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={40} />
        </div>
        <div
          style={{
            paddingTop: "8%",
            paddingBottom: "8%",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <h4>Please wait.... </h4>
          <p>Submitting your request</p>
          <p style={{ lineHeight: "0.1px" }}><i>This may take up to a minute....</i></p>
        </div>
      </div> : ""}

      {/* view by ernesto */}
      {showView &&
        <View
          submitfunction={submitFormData}
          title={"Review details"}
          xdata={formData}
          xlabel={formLabel}
          closeClick={closeClick}
          height={"530px"}
          skipConfirmation={routeName === 'dedicatedvirtualnetworksetup'}
        />
      }

      {/* Dedicated VPC Loading Dialog */}
      {dedicatedVPCLoading && (
        <CommonDialog
          open={dedicatedVPCLoading}
          title="Loading Approvers"
          dialogType="fui"
          textContent={
            <div style={{ textAlign: "center", padding: "40px 20px" }}>
              <CircularProgress size={40} style={{ marginBottom: "20px" }} />
              <p>Fetching available approvers for your Dedicated VPC request...</p>
              <p style={{ fontSize: "14px", color: "#666" }}>Please wait a moment.</p>
            </div>
          }
        />
      )}

      {/* Dedicated VPC Custom Review Dialog */}
      {showDedicatedVPCReview && (
        <CommonDialog
          open={showDedicatedVPCReview}
          onClose={() => setShowDedicatedVPCReview(false)}
          title="Review Dedicated VPC Request Details"
          dialogType="fui"
          textContent={
            <div style={{ padding: "20px" }}>
              <p style={{ marginBottom: "20px", fontWeight: "500" }}>
                Please review your Dedicated VPC request details:
              </p>
              <div style={{ marginBottom: "20px" }}>
                {Object.entries(dedicatedVPCReviewData).map(([key, value]) => (
                  <div key={key} style={{ marginBottom: "8px", display: "flex" }}>
                    <strong style={{ minWidth: "150px", marginRight: "10px" }}>{key}:</strong>
                    <span>{value || "N/A"}</span>
                  </div>
                ))}
              </div>
            </div>
          }
          dialogActions={
            <DialogActions>
              <Button onClick={() => setShowDedicatedVPCReview(false)}>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setShowDedicatedVPCReview(false);
                  handleDedicatedVPCApproval();
                }}
                style={{ background: "#7500C0", color: "#FFF" }}
              >
                Proceed to Approval
              </Button>
            </DialogActions>
          }
        />
      )}

      {/* Dedicated VPC Independent Approval Dialog */}
      {showDedicatedVPCApproval && (
        <CommonDialog
          open={showDedicatedVPCApproval}
          onClose={() => setShowDedicatedVPCApproval(false)}
          title="Select Approver for Dedicated VPC"
          dialogType="fui"
          textContent={
            <div style={{ padding: "20px" }}>
              <p style={{ marginBottom: "20px" }}>
                Please select an approver for your Dedicated VPC request:
              </p>
              <Autocomplete
                options={dedicatedVPCApprovers}
                value={selectedDedicatedVPCApprover}
                onChange={(event, newValue) => setSelectedDedicatedVPCApprover(newValue || "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Approver"
                    variant="outlined"
                    fullWidth
                    required
                  />
                )}
              />
            </div>
          }
          dialogActions={
            <DialogActions>
              <Button onClick={() => setShowDedicatedVPCApproval(false)}>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  if (selectedDedicatedVPCApprover) {
                    setShowDedicatedVPCApproval(false);
                    // Direct submission after approver selection
                    handleDedicatedVPCSubmission();
                  }
                }}
                disabled={!selectedDedicatedVPCApprover}
                style={{ background: "#7500C0", color: "#FFF" }}
              >
                Submit Request
              </Button>
            </DialogActions>
          }
        />
      )}

      <GenWiz open={true} appconfig={gwconfig} />
    </>
  );
};

const MSTP = (state) => ({
  activeStep: state.fui.activeStep,
  listenerClearLocalData: state.fui.listenerClearLocalData,
  DPForm: state.fui.DPForm,
  GWLForm: state.fui.GWLForm,
  ADForm: state.fui.ADForm,
  WPForm: state.fui.WPForm,
  configurationType: state.fui.configurationType,
  email: state.auth.userDetails.email,
  isUserApprovalWhitelisted: state.fui.isUserApprovalWhitelisted,
  isFormSubmittedSuccessful: state.fui.isFormSubmittedSuccessful,
  apiError: state.fui.apiError,
  isFormValidationSuccessful: state.fui.isFormValidationSuccessful,
  isFormSubmittedFailed: state.fui.isFormSubmittedFailed,
  isEnhancedApprovalSubmitted: state.fui.isEnhancedApprovalSubmitted,
  enhancedApprovalError: state.fui.enhancedApprovalError,
  approversData: state.fui.approversData,
  approversEnhancedData: state.fui.approversEnhancedData,
  approversGtad: state.fui.approversGtad,
  validationData: state.fui.validationData,
  isLoading: state.fui.isLoading,
  isSubmitFormLoading: state.fui.isSubmitFormLoading,
  isRootExist: state.fui.isRootExist,
  externalClientError: state.fui.externalClientError,
  MPForm: state.fui.MPForm,
  PIForm: state.fui.PIForm,
  PAMForm: state.fui.PAMForm,
  UTKMForm: state.fui.UTKMForm,
  OPSForm: state.fui.OPSForm,
  AALForm: state.fui.AALForm,
  ATRForm: state.fui.ATRForm,
  EventOpsForm: state.fui.EventOpsForm,
  TuringForm: state.fui.TuringForm,
  StormSeerForm: state.fui.StormSeerForm,
  ATRSaaSForm: state.fui.ATRSaaSForm,
  SPLUCLUForm: state.fui.SPLUCLUForm,
  Stack360Form: state.fui.Stack360Form,
  SIForm: state.fui.SIForm,
  KQForm: state.fui.KQForm,
  ECCForm: state.fui.ECCForm,
  AMForm: state.fui.AMForm,
  CIAForm: state.fui.CIAForm,
  CPForm: state.fui.CPForm,
  BRForm: state.fui.BRForm,
  GAForm: state.fui.GAForm,
  AOPForm: state.fui.AOPForm,
});
PlatformLicenseStepper.propTypes = {
  /**
   * Match property of route library
   */
  match: PropTypes.object,
  /**
   *
   */
  clearLocalComponentData: PropTypes.func,
  /**
   * Redux function to update an instance.
   */
  updateASelectedInstance: PropTypes.func,
};

export default withRouter(
  connect(MSTP, {
    updateASelectedInstance: fuiRedux.updateASelectedInstance,
    submitForm: fuiRedux.submitForm,
    submitFormNonApproval: fuiRedux.submitFormNonApproval,
    submitFormWhitelistedUser: fuiRedux.submitFormWhitelistedUser,
    submitFormEnhancedApproval: fuiRedux.submitFormEnhancedApproval,
    updateLoading: fuiRedux.updateLoadingForm,
    updateSuccessSubmit: fuiRedux.updateSuccessSubmit,
    updateFailedSubmit: fuiRedux.updateFailedSubmit,
    validateForm: fuiRedux.validateForm,
    checkIsUserApprovalWhitelisted: fuiRedux.checkIsUserApprovalWhitelisted,
    generateDPSubmitData,
    generateUTKMSubmitData,
    generateGWLSubmitData,
    generateADSubmitData,
    generateWPSubmitData,
    tokenValidation,
    updatePIForm: fuiRedux.updatePIForm,
    updatePAMForm: fuiRedux.updatePAMForm,
    updateUTKMForm: fuiRedux.updateUTKMForm,
    updateCPForm: fuiRedux.updateCPForm,
  })(PlatformLicenseStepper)
);